import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import ActivityTable from "../../../img/ActivityTableStep3.png";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";

class HLStep3Form extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    onTemplatesClick = () => {
        window.open("./resources/" + HLConst.templatesXLSX, "_blank");
    };

    onImgSourceClick = () => {
        window.open("https://evaluationplanningtool.org");
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        const ActivityTableImg = (
            <img
                style={{
                    width: "100%",
                }}
                src={ActivityTable}
                alt="ActivityTable"
            />
        );

        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                    marginRight: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                    }}
                >
                    {HLConst.step3AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step3AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    For each priority intervention identified in step 2, identify if it is relevant for your setting
                    given current coverage levels and service delivery packages.
                </p>

                <p>
                    For the top five or ten priority interventions, brainstorm activities (new or areas you want to
                    scale up) that will help you increase coverage of the relevant priority interventions.
                </p>

                <ul>
                    <li>
                        What is preventing me from increasing coverage? Put another way, what are my current challenges
                        with regards to delivering this intervention?
                    </li>
                    <li>Are the bottlenecks related to the supply- and/or demand-side?</li>
                </ul>

                {/*<p>*/}
                {/*For example, it may be that you don’t have enough staff to provide services on certain days,*/}
                {/*or during certain hours. It could be that health seeking behavior is low.*/}
                {/*</p>*/}

                {ActivityTableImg}

                <p
                    style={{
                        fontSize: 9,
                    }}
                >
                    Source:&nbsp;
                    <Link
                        onClick={this.onImgSourceClick}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        https://evaluationplanningtool.org
                    </Link>
                </p>
                {/*Source: Roberton, Tim. Aurora Health Systems Modeling Tool. September 2019*/}
                <p>
                    Complete the&nbsp;
                    <Link
                        onClick={this.onTemplatesClick}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        activity table
                    </Link>
                    &nbsp;for your top prioritized interventions.
                </p>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;Your number one prioritized intervention from step 2 is treatment for moderate acute
                        malnutrition (MAM). You decide this is feasible in your setting, and the activities you want to
                        implement to increase coverage are community sensitization and increased distribution of
                        ready-to-use supplemental foods.
                        <br></br>
                        <br></br>
                        If coverage of a particular intervention has already reached 95%, there may be no need to
                        identify activities to further increase coverage. Or perhaps in your humanitarian context some
                        activities are only done by other partners, either due to government regulations or their chosen
                        focus. Obviously if the intervention results from step 2 aren’t relevant, skip to the next
                        intervention in the list.
                    </p>

                    {/*<p>*/}
                    {/*Your number one prioritized intervention from step 2 is treatment for moderate acute*/}
                    {/*malnutrition (MAM). You decide this is feasible in your setting, and the activity you need*/}
                    {/*to target to increase coverage is community sensitization.*/}
                    {/*</p>*/}
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        // const downloadGuideBtn =
        //     <HLDownloadGuideBtn/>;

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step2Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.step4Form)}
            />
        );

        return (
            <div>
                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLStep3Form;
